import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { AppCard, AppNoInfo } from "@/layout/AppComponents";
import axios from "axios";
import styled from "styled-components";
import ReactDOMServer from "react-dom/server";
import Translator from "../../../../layout/components/helpers/Translator";
import { axiosPath } from "../../../../routing/helpers/router";
import BreadcrumbHandler from "../../../../layout/components/breadcrumb/BreadcrumbHandler";
import { statusSteps } from "../../../../layout/screenSpecifics/Modules/CommunicationPipeline/constants/options";
import CommunicationPipelineAdminNavbar from "../../../../layout/screenSpecifics/Modules/CommunicationPipeline/Admin/CommunicationPipelineAdminNavbar";
import CommunicationPipelineStatusTimeLine from "../../../../layout/screenSpecifics/Modules/CommunicationPipeline/CommunicationPipelineStatusTimeLine";
import * as currentPageAction from "@/store/actions/currentPageAction";
import errorHandler from "@/layout/components/error/ErrorHandler";
import CommunicationPipelineModuleSidebar from "@/layout/screenSpecifics/Modules/CommunicationPipeline/CommunicationPipelineModuleSidebar";

export default function CommunicationPipelineAdminReportStatusScreen() {
  const { moduleBridgeHex, reportHex } = useParams();
  const dispatch = useDispatch();
  const moduleData = useSelector((state) => state.currentPage?.moduleData);
  const [report, setReport] = useState();

  const loadReport = useCallback(async () => {
    axios
      .post(axiosPath("api_r_user_module_communicationPipeline_report_get"), {
        moduleBridgeHex,
        reportHex,
      })
      .then((r) => {
        setReport(r?.data);
      })
      .catch((e) => dispatch(errorHandler(e)));
  }, [moduleBridgeHex, reportHex]);

  const getStepDescription = useCallback(
    (step) => {
      const index = statusSteps.findIndex(
        (statusStep) => statusStep.value === step,
      );

      return (
        <>
          <h6>{statusSteps[index]?.label}</h6>
          <div>{statusSteps[index]?.description}</div>
        </>
      );
    },
    [report],
  );

  // > LOAD MODULE DATA //
  useEffect(() => {
    axios
      .post(
        axiosPath("api_r_user_module_communicationPipeline_getModuleData"),
        { moduleBridgeHex },
      )
      .then((r) => {
        dispatch(currentPageAction.change("moduleData", r.data, true));
      });
  }, []);
  // > LOAD MODULE DATA //

  useEffect(() => {
    loadReport();
  }, []);

  if (!moduleData) return <AppNoInfo />;

  return (
    <>
      {moduleData?.permissionLevel === 0 && (
        <CommunicationPipelineModuleSidebar />
      )}
      <Container>
        <BreadcrumbHandler
          paths={
            moduleBridgeHex
              ? [
                  {
                    name: `${moduleData?.moduleName}`,
                    route: {
                      name: "user_module_communicationPipeline_home",
                      params: {
                        moduleBridgeHex,
                      },
                    },
                  },
                  {
                    name: `${ReactDOMServer.renderToString(
                      <Translator
                        file="module-communicationPipeline"
                        name="complaint"
                      />,
                    )} - ${reportHex}`,
                  },
                ]
              : [{ name: "..." }]
          }
        />
        {report && (
          <>
            <CommunicationPipelineAdminNavbar />
            <AppCard className="mb-1">
              <div className="mt-5">
                <div className="row">
                  <div className="col-lg-12">
                    <CommunicationPipelineStatusTimeLine
                      report={report}
                      isAdmin
                    />
                    <div className="alert alert-info mt-5">
                      {getStepDescription(report?.status?.step)}
                    </div>
                  </div>
                </div>
              </div>
            </AppCard>
          </>
        )}
      </Container>
    </>
  );
}

const Container = styled.div`
  padding-left: 0.5rem !important;
  padding-bottom: 100px;
  h3 {
    font-size: 14px;
    font-weight: 700;
    margin: 32px 0 0 0;
  }
  .user-info {
    border: 1px solid lightgray;
    padding: 24px;
  }
`;
